export default function TwoN() {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.5498 7.94339C19.4559 2.16005 12.8697 10.0824 13.8219 15.0735C6.84649 18.793 10.4811 27.5717 16.2628 27.5909H48.8163C58.3385 25.4518 55.4025 15.6281 49.7685 14.519C50.7207 -2.11807 31.3587 -2.27651 27.5498 7.94339Z" fill="#525252" />
      <path d="M18.5498 16.9434C10.4559 11.16 3.86966 19.0824 4.82189 24.0735C-2.15351 27.793 1.48113 36.5717 7.26284 36.5909H39.8163C49.3385 34.4518 46.4025 24.6281 40.7685 23.519C41.7207 6.88193 22.3587 6.72349 18.5498 16.9434Z" fill="url(#paint0_linear_31_155)" />
      <defs>
        <linearGradient id="paint0_linear_31_155" x1="31.8757" y1="13.6969" x2="1" y2="36.5909" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.72" />
        </linearGradient>
      </defs>
    </svg>

  )
}
